import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]



interface Prop {
  href: string
  icon?: 'Twitter' | 'GitHub' | 'YouTube'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IconLink',
  props: {
    href: null,
    icon: null
  },
  setup(__props: any) {

const prop = __props as {
  href: string
  icon?: 'Twitter' | 'GitHub' | 'YouTube'
};



function getIcon() {
  switch (prop.icon) {
    case 'Twitter':
      return require('@/assets/icons/twitter_blue.svg')
    case 'GitHub':
      return require('@/assets/icons/github.svg')
    case 'YouTube':
      return require('@/assets/icons/youtube_red.svg')
    default:
      break;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("a", {
    href: __props.href,
    target: "_blank",
    class: "text-h6 q-pa-none"
  }, [
    _renderSlot(_ctx.$slots, "icon", {}, () => [
      _createVNode(_component_q_img, {
        src: getIcon(),
        width: "1.3rem",
        class: "q-mr-xs"
      }, null, 8, ["src"])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})